module.exports = __webpack_public_path__ + "img/fiberapi.0b9dfd8d.png";